import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const OPTIONS = [["recent", "Recently Added"], ["oldest", "Oldest First"], ["az", "Name A–Z"], ["za", "Name Z–A"]];
const addedAt = (r) => r.created_at || (r.id && r.id.length === 24 ? new Date(parseInt(r.id.slice(0, 8), 16) * 1000).toISOString() : "");

export function sortRecords(list, sort) {
  const out = [...list];
  if (sort === "recent" || sort === "oldest") {
    out.sort((a, b) => addedAt(b).localeCompare(addedAt(a)));
    if (sort === "oldest") out.reverse();
  } else {
    out.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    if (sort === "za") out.reverse();
  }
  return out;
}

export default function SortSelect({ value, onChange, testid = "sort-select" }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-9 w-full text-sm sm:w-44" data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>{OPTIONS.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`${testid}-${v}`}>{l}</SelectItem>)}</SelectContent>
    </Select>
  );
}
